import { Box, BoxProps, Grid } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import React from 'react';
import { Responsiveness } from '../../../theme/overrides';

interface Props extends BoxProps {
    heading?: React.ReactNode;
}

const Section = ({ heading, children, onClick, ...props }: Props) => {
    const { isMobile } = Responsiveness()
    return (
        <Box bgcolor="#fff" component="section">
            {(heading || onClick) && (
                <Grid
                    container
                    alignItems="center"
                    component="div"
                    onClick={onClick}
                    style={{
                        cursor: onClick ? 'pointer' : 'default'
                    }}
                    mb={1}
                >
                    <Grid item flexGrow={1}>
                        {heading}
                    </Grid>
                    {onClick && (
                        <ArrowRightIcon fontSize="large" htmlColor="#055C7F" />
                    )}
                </Grid>
            )}
            <Box
                py={1}
                // px={5}
                px={{ xs: '16px', sm: '20px', lg: '40px' }}
                mb={{ xs: 1, lg: 1 }}
                bgcolor="#fff"
                borderRadius={1.5}
                {...props}
            >
                {children}
            </Box>
        </Box>
    );
};

export default Section;
